import React, { useEffect, useMemo, useState } from "react";
import "./CSS/CertificadosGenerados.css";
import { dominio } from "../../../routes_backend/routes.jsx";

// const API_URL = "http://192.168.3.79:5000/getCertificadosGenerados";
const API_URL = `${dominio}/getCertificadosGenerados`;

// const res = await fetch(`${dominio}/getProductosCertificadosCalidad`);

const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

const fmtDate = (iso) => {
  if (!iso) return "Sin fecha";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return safeStr(iso);
  return d.toLocaleString("es-GT");
};

const fmtNum = (v, digits = 2) => {
  if (v === null || v === undefined || v === "") return "N/D";
  const n = Number(v);
  if (Number.isNaN(n)) return safeStr(v);
  return n.toLocaleString("es-GT", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

/** Convierte base64 -> ObjectURL, usando File para que el visor no muestre "untitled" */
const base64ToBlobUrl = (
  base64,
  mime = "application/pdf",
  filename = "Certificado de Calidad.pdf"
) => {
  if (!base64) return null;

  // Soporta base64 puro o dataURL "data:application/pdf;base64,..."
  const cleaned = base64.includes(",") ? base64.split(",")[1] : base64;

  const byteChars = atob(cleaned);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);

  const u8 = new Uint8Array(byteNumbers);

  // File con nombre -> el viewer ya no queda "untitled" (depende del visor)
  const file = new File([u8], filename, { type: mime });

  return URL.createObjectURL(file);
};

const CertificadosGenerados = () => {
  const [certificados, setCertificados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [search, setSearch] = useState("");

  // ===== Modal viewer state =====
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerTitle, setViewerTitle] = useState("");
  const [viewerUrl, setViewerUrl] = useState(null);

  const openInModal = (
    base64,
    title,
    mime = "application/pdf",
    filename = "Certificado de Calidad.pdf"
  ) => {
    try {
      const url = base64ToBlobUrl(base64, mime, filename);
      if (!url) return;

      // Si ya había uno abierto, revócalo
      if (viewerUrl) URL.revokeObjectURL(viewerUrl);

      setViewerTitle(title);
      setViewerUrl(url);
      setViewerOpen(true);
    } catch (e) {
      console.error("Error abriendo base64 en modal:", e);
      alert("No se pudo abrir el archivo. Revisa consola.");
    }
  };

  const closeModal = () => {
    setViewerOpen(false);
    if (viewerUrl) URL.revokeObjectURL(viewerUrl);
    setViewerUrl(null);
    setViewerTitle("");
  };

  // Cierra con ESC y bloquea scroll cuando el modal está abierto
  useEffect(() => {
    if (!viewerOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") closeModal();
    };

    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewerOpen]);

  // Limpieza al desmontar
  useEffect(() => {
    return () => {
      if (viewerUrl) URL.revokeObjectURL(viewerUrl);
    };
  }, [viewerUrl]);

  const fetchCertificados = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(API_URL, {
        headers: { "Content-Type": "application/json" },
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(`Error ${res.status}: ${txt}`);
      }

      const data = await res.json();
      setCertificados(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setError(err.message || "Error al obtener certificados");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCertificados();
  }, []);

  const filtered = useMemo(() => {
    if (!search) return certificados;
    const q = search.toLowerCase();

    return certificados.filter((c) => {
      const producto = safeStr(c.Producto).toLowerCase();
      const cliente = safeStr(c.Cliente).toLowerCase();
      const proyecto = safeStr(c.NombreProyecto).toLowerCase();
      const asesor = safeStr(c.NombreAsesor).toLowerCase();
      const correo = safeStr(c.CorreoAsesor).toLowerCase();
      const estado = safeStr(c.Estado).toLowerCase();
      const planta = safeStr(c.PlantaProduccion).toLowerCase();

      const boleta = safeStr(c.U_boleta_ult).toLowerCase();
      const ot = safeStr(c.U_ot).toLowerCase();

      return (
        producto.includes(q) ||
        cliente.includes(q) ||
        proyecto.includes(q) ||
        asesor.includes(q) ||
        correo.includes(q) ||
        estado.includes(q) ||
        planta.includes(q) ||
        boleta.includes(q) ||
        ot.includes(q)
      );
    });
  }, [certificados, search]);

  return (
    <div className="solicitud-traslado-container">
      <header className="solicitud-traslado-header">
        <div>
          <h1>Certificados Generados</h1>
          <p>Listado de certificados con validación y registros SAP</p>
        </div>

        <div className="solicitud-traslado-actions">
          <input
            type="text"
            placeholder="Buscar por producto, cliente, proyecto, asesor, estado, planta, boleta u OT..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </header>

      {loading && (
        <div className="solicitud-traslado-status status-loading">Cargando certificados...</div>
      )}

      {error && (
        <div className="solicitud-traslado-status status-error">Ocurrió un error: {error}</div>
      )}

      {!loading && !error && filtered.length === 0 && (
        <div className="solicitud-traslado-status status-empty">
          No hay certificados que coincidan con el filtro.
        </div>
      )}

      <section className="solicitud-traslado-list">
        {filtered.map((c) => {
          const id = c.Id;

          const porcentaje =
            c.porcentajeAprox != null && c.porcentajeAprox !== ""
              ? Number(c.porcentajeAprox)
              : null;
          const porcentajeTxt =
            porcentaje == null || Number.isNaN(porcentaje) ? "N/D" : `${porcentaje}%`;

          const hasAdjunto = !!c.Adjunto;
          const hasCertificado = !!c.CertificadoAdjunto;

          // ===== Estado badge (P/G) =====
          const estadoRaw = safeStr(c.Estado).trim().toUpperCase();
          const estadoInfo =
            estadoRaw === "P"
              ? { text: "Pendiente", cls: "estado-badge estado-p" }
              : estadoRaw === "G"
              ? { text: "Generado", cls: "estado-badge estado-g" }
              : { text: estadoRaw || "N/D", cls: "estado-badge estado-nd" };

          return (
            <article key={id} className="solicitud-card">
              <div className="solicitud-card-header">
                <div className="solicitud-card-main">
                  <h2>Certificado #{id}</h2>

                  <p className="solicitud-card-subtitle">
                    Producto: <strong>{safeStr(c.Producto) || "N/D"}</strong> &nbsp;·&nbsp;
                    Planta: <strong>{safeStr(c.PlantaProduccion) || "N/D"}</strong>
                  </p>

                  <p className="solicitud-card-comments">
                    Cliente: <strong>{safeStr(c.Cliente) || "N/D"}</strong> {" · "}
                    Proyecto: <strong>{safeStr(c.NombreProyecto) || "N/D"}</strong>
                  </p>

                  <p className="solicitud-card-comments">
                    Asesor: <strong>{safeStr(c.NombreAsesor) || "N/D"}</strong> {" · "}
                    Correo: <strong>{safeStr(c.CorreoAsesor) || "N/D"}</strong>
                  </p>
                </div>

                <div className="solicitud-card-meta">
                  <span className={estadoInfo.cls} title={`Estado: ${estadoInfo.text}`}>
                    {estadoInfo.text}
                  </span>

                  <span className="solicitud-date">Creación: {fmtDate(c.FechaHoraCreacion)}</span>

                  <span className="solicitud-date">
                    {/* % Aprox: <strong>{porcentajeTxt}</strong> */}
                  </span>

                  <button
                    type="button"
                    className="solicitud-transfer-btn"
                    disabled={!hasAdjunto}
                    onClick={() => {
                      openInModal(
                        c.Adjunto,
                        `Adjunto · Certificado #${id}`,
                        "application/pdf",
                        "Certificado de Calidad.pdf"
                      );
                    }}
                    title={hasAdjunto ? "Abrir adjunto" : "Sin adjunto"}
                  >
                    Ver Adjunto
                  </button>

                  <button
                    type="button"
                    className="solicitud-transfer-btn"
                    disabled={!hasCertificado}
                    onClick={() => {
                      openInModal(
                        c.CertificadoAdjunto,
                        `Certificado · Certificado #${id}`,
                        "application/pdf",
                        "Certificado de Calidad.pdf"
                      );
                    }}
                    title={hasCertificado ? "Abrir certificado" : "Sin certificado"}
                  >
                    Ver Certificado
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </section>

      {/* ===== Modal Viewer ===== */}
      {viewerOpen && (
        <div className="modal-overlay" onClick={closeModal} role="dialog" aria-modal="true">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">{viewerTitle}</h3>

              <div className="modal-actions">
                {viewerUrl && (
                  <a
                    className="modal-link"
                    href={viewerUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Abrir en nueva pestaña"
                  >
                    Abrir en pestaña
                  </a>
                )}
                <button className="modal-close" onClick={closeModal} aria-label="Cerrar modal">
                  ✕
                </button>
              </div>
            </div>

            <div className="modal-body">
              {viewerUrl ? (
                <iframe
                  title={viewerTitle}
                  src={viewerUrl}
                  style={{ width: "100%", height: "75vh", border: "none" }}
                />
              ) : (
                <div style={{ padding: 16 }}>No hay documento para mostrar.</div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CertificadosGenerados;